/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareLinkedEntity } from '../fw/MetaDataHelper';
import * as Permission from '../util/Permission';
import {PARSERS, PARSER_BINARY_WRAPPER, FILTER_TYPE_NONE, FILTER_BUILDERS} from './ChannelDefType';

export const OPERATION_AUTH = "auth";
export const OPERATION_AUTH2 = "auth2";
export const OPERATION_AUTH3 = "auth3";
export const OPERATION_CREATE = "create";
export const OPERATION_READ = "read";
export const OPERATION_UPDATE = "update";
export const OPERATION_DELETE = "delete";
export const OPERATION_LIST = "list";
export const OPERATION_SEARCH = "search";
export const OPERATION_SEARCH_BY_FILTER = "search-filter";
export const OPERATION_PDF = "pdf";
export const OPERATION_OTHER = "other";

export let actionOperations = {
    [OPERATION_AUTH]: {
        "name": "Authenticate attempt",
    },
    [OPERATION_CREATE]: {
        "name": "Create",
    },
    [OPERATION_READ]: {
        "name": "Read"
    },
    [OPERATION_UPDATE]: {
        "name": "Update"
    },
    [OPERATION_DELETE]: {
        "name": "Delete"
    },
    [OPERATION_LIST]: {
        "name": "List"
    },
    [OPERATION_SEARCH]: {
        "name": "Search"
    },
    [OPERATION_SEARCH_BY_FILTER]: {
        "name": "Search by filter builder"
    },
    [OPERATION_PDF]: {
        "name": "Export to PDF"
    },
    [OPERATION_OTHER]: {
        "name": "Other"
    }
};

export const INVOCATION_STYLE_FIRST_LINE_ONLY = "first-line-only";
export const INVOCATION_STYLE_PER_LINE = "per-line";
export const INVOCATION_STYLE_JOIN = "join";



export default declareLinkedEntity({
    entity: "actionDefs",
    graphQL: "ActionDef",
    name: "Action Definition",
    defaultOrder: ['name', 'type'],
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    parentRelation: 'actionDefs',
    defaultTitle: (data) => {
        return data['name'] ? data['name'] : (actionOperations[data['operation']] ? actionOperations[data['operation']].name : "");
    },
    dynamoPrefix: 'def',
    storageType: 'schema',
    onModify: ['channelDef'],
    fields: (types) => { return {
        id: {
            name: "Action Definition ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
            compositeKey: true,
        },
        channelDef: {
            name: "Application Definition",
            type: "relation",
            to: () => types['channelDefs'],
            defaultValue: (channelDef) => {
                return channelDef['id'];
            },
            required: true,
            parent: true,
            hiddenCreate: true,
            compositeKey: true,
        },
        sourceDef: {
            name: "Source Definition",
            type: "relation",
            to: () => types['sourceDefs'],
            relativeTo: ['channelDef'],
        },
        dependsOn: {
            name: "Depends on Source Definition",
            type: "relation",
            to: () => types['sourceDefs'],
            relativeTo: ['channelDef'],
        },
        operation: {
            name: "Operation",
            type: "enum",
            required: true,
            defaultValue: OPERATION_SEARCH,
            values: actionOperations
        },
        name: {
            name: "Name",
            trim: true,
            type: "string",
            translatable: true,
            defaultValue: "",
        },
        multiAction: {
            name: "Multiple Action Processing",
            type: "enum",
            defaultValue: '',
            values: {
                '': {
                    name: '-'
                },
                'parallel': {
                    name: 'Parallel'
                }
            },
        },
        actionExpressionName: {
            name: "Action Expression Name",
            description: "Name of multi-action variable (eg. input)",
            type: "string",
            visibility: (data) => { return data['multiAction'] ? true : false; },
        },
        actionExpression: {
            name: "Action Expression",
            description: "Value of multi-action variable (eg. ${array(input1, input2)}).",
            type: "string",
            visibility: (data) => { return data['multiAction'] ? true : false; },
        },
        isAutoGenerated: {
            name: "Is AutoGenerated",
            type: "boolean",
            defaultValue: false,
            userEditable: false,
        },
        useForDatiQuery: {
            name: "Allow use in dynamic DatiQuery",
            type: "boolean",
            defaultValue: true
        },
        useForSearch: {
            name: "Allow use for Search Action",
            type: "boolean",
            defaultValue: true
        },
        useForInvoke: {
            name: "Allow use as Action Invocation",
            type: "boolean",
            defaultValue: false
        },
        invocationStyle: {
            name: "Invocation style",
            type: "enum",
            defaultValue: INVOCATION_STYLE_PER_LINE,
            values: {
                [INVOCATION_STYLE_FIRST_LINE_ONLY]: {
                    name: 'Call on first row only',
                },
                [INVOCATION_STYLE_PER_LINE]: {
                    name: 'Call for every row',
                    description: 'Call for every row and merge results.'
                },
                [INVOCATION_STYLE_JOIN]: {
                    name: 'One call for every rows combined',
                },
            },
            visibility: (data) => { return data['useForSearch'] || data['useForInvoke'] || data['useForDatiQuery']; },
        },
        useDefaultFetcher: {
            name: "Use default Fetcher",
            type: "boolean",
            defaultValue: true
        },
        useDefaultFilter: {
            name: "Use default Filter Builder",
            type: "boolean",
            defaultValue: true
        },
        filterBuilder: {
            name: "Filter builder",
            type: "enum",
            defaultValue: FILTER_TYPE_NONE,
            values: FILTER_BUILDERS,
            visibility: (data) => { return !data['useDefaultFilter']; },
        },
        useDefaultParser: {
            name: "Use default Parser",
            type: "boolean",
            defaultValue: true
        },
        parser: {
            name: "Parser",
            type: "enum",
            values: PARSERS,
            visibility: (data) => { return !data['useDefaultParser']; },
        },
        javaScript: {
            name: "JavaScript",
            type: "javascript",
            permission: Permission.PERM_EDIT_CHANNEL_DEF,
            globalVariables: {
                'options': 'options',
                'channelDef': 'channelDef',
                'channel': 'channel',
                'fetcherOptions': 'fetcherOptions',
                'setOptions': 'setOptions(newOptions)',
                'setAuthOptions': 'setAuthOptions(newOptions)',
                'setCurrentUserOptions': 'setCurrentUserOptions(newOptions)',
                'doAction': 'doAction(args)',
            }
        },
        useDefaultMapper: {
            name: "Use default Mapper",
            type: "boolean",
            defaultValue: true
        },
        useMapperForChannelDef: {
            name: "Use mapper for Channel Def",
            type: "string",
            visibility: (data) => { return !data['useDefaultMapper']; },
        },
        isBinary: {
            name: "Is Binary?",
            type: "boolean",
            defaultValue: false,
            visibility: (data) => { return data['parser'] === PARSER_BINARY_WRAPPER; },
        },
        useDefaultPager: {
            name: "Use default Pager",
            type: "boolean",
            defaultValue: true
        },
        caching: {
            name: "Caching",
            type: "enum",
            defaultValue: 'none',
            values: {
                "none": {
                    name: 'No caching',
                },
                "per-channel": {
                    name: 'Activated',
                },
                "global": {
                    name: 'Global (across users)',
                },
            },
            visibility: (data) => { return data['useForSearch'] || data['useForDatiQuery']; },
        },
        actionMeaning: {
            name: "Search action meaning",
            type: "enum",
            defaultValue: '',
            values: {
                "": {
                    name: "-",
                },
                "company-search": {
                    name: 'Company Search',
                },
            },
            visibility: (data) => { return data['useForSearch']; },
        },
        mapAsFetchOneRow: {
            name: "Use Mapper as fetch One",
            type: "boolean",
            defaultValue: false
        },
        fetcherOptions: {
            name: "Fetcher Options",
            type: "object",
            defaultValue: {},
        },
        parserOptions: {
            name: "Parser Options",
            type: "object",
            defaultValue: {},
        },
        errorAsNothingFound: {
            name: "Error means nothing found",
            description: "Some APIs returns error (400) instead of 'nothing is found'.",
            type: "boolean",
            defaultValue: false
        },
        filterOptions: {
            name: "Filter Options",
            type: "object",
            defaultValue: {},
        },
        pagerOptions: {
            name: "Pager Options",
            type: "object",
            defaultValue: {},
        },
        options: {
            name: "Options",
            type: "object",
            defaultValue: {},
        },
        description: {
            name: "Description",
            type: "text",
            translatable: true,
            defaultValue: ""
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        swaggerId: {
            name: "Swagger Id",
            type: "string",
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
    }; },
    relations: (types) => { return {
        actionInputDefs: {
            type: 'oneToMany',
            to: types['actionInputDefs'],
            export: true,
            defaultValue: () => {
                return {};
            },
        },

    }; }

});
